<user-authentication
  [urlBrasao]="urlBrasao"
  [entidadeCidade]="entidadeCidade"
></user-authentication>
